<ng-container *ngIf="promotion">
  <div class="card-wrapper">
    <div class="gift-back"></div>
    <div class="gift-card-box">
      <myclubrewards-card
        [config]="promotion"
        class="gift-card"
      ></myclubrewards-card>
    </div>
  </div>
</ng-container>
